import VideoCard from './video-card'

export default VideoCard
